'use strict';

var _ = require('lodash');
var toastr = require('toastr');
function GridNDReoptPreviewNotSendButtonController($scope, $interval, momentService, scenarioService, saveButtonUtilsService, reoptPreviewDataUtilsService, reoptimizationSaveService, reoptimizationService, FlightAnalysisGridService) {
  var gridPanel = $scope.gridPanelScope;
  var checkStatusInterval;
  var flightManagementGrids = ['inventory-management', 'overbooking-management'];
  $scope.selectedRows = [];
  $scope.checkPreviewStatusInterval = function () {
    $scope.cancelCheckStatusInterval();
    checkStatusInterval = $interval(function () {
      $scope.checkPreviewStatus();
    }, 2500);
  };
  $scope.cancelCheckStatusInterval = function () {
    if (checkStatusInterval) {
      $interval.cancel(checkStatusInterval);
    }
  };
  $scope.checkPreviewStatus = function () {
    if (reoptPreviewDataUtilsService.isNdReopt(gridPanel.reoptPreviewData)) {
      var departureDate = momentService.copy(gridPanel.reoptPreviewData.ndReopt.flightDepartureDateMoment, momentService.FIELD.ND_DEPARTURE_DATE).toISOString();
      var flightNumber = gridPanel.reoptPreviewData.ndReopt.flightNumber;
      reoptimizationService.getStatus(departureDate, flightNumber, scenarioService.getCurrentUserNDPreviewRequestName()).then(function (response) {
        if (_.isEmpty(response)) {
          return;
        }
        var status = response[0].status;
        if (status === 'ERROR-PROCESSING') {
          $scope.cancelCheckStatusInterval();
          showError('Error occurred during Optimization Processing for Flight Number ' + flightNumber + ' and Departure Date:' + departureDate);
          gridPanel.reoptPreviewData.ndReopt = undefined;
          $scope.data.flightReopt = 'reoptPreview';
        } else if (status === 'FINISHED-PROCESSING' && !!gridPanel.reoptPreviewData.ndReopt) {
          $scope.cancelCheckStatusInterval();
          toastr.success('Reopt preview finished processing');
          gridPanel.reoptPreviewData.ndReopt.success = true;
          $scope.getReoptimizedFlight();
        }
      });
    } else {
      $scope.cancelCheckStatusInterval();
    }
  };
  $scope.isRunning = function () {
    return !!(gridPanel.reoptPreviewData.ndReopt && !gridPanel.reoptPreviewData.ndReopt.success);
  };
  $scope.isReoptFinished = function () {
    return !!(gridPanel.reoptPreviewData.ndReopt && gridPanel.reoptPreviewData.ndReopt.success && !gridPanel.reoptPreviewData.ndReopt.read);
  };
  $scope.sendOptimization = function () {
    if (gridPanel.reoptPreviewData.ndReopt && !gridPanel.reoptPreviewData.ndReopt.success) {
      return;
    }
    var scenarioName = scenarioService.NDPreviewRequest;
    var saveDataArray = prepareDataForSaving(scenarioName);
    reoptPreviewDataUtilsService.initNdReopt(gridPanel.reoptPreviewData, $scope.selectedRows[0]);
    toastr.success('Submitting flight reopt preview request');
    reoptimizationSaveService.saveDataBeforeReoptPrev(saveDataArray, scenarioName).then(function () {
      return $scope.reOptimize('N', true, scenarioName);
    }).then(function () {
      $scope.checkPreviewStatusInterval();
    });
  };
  $scope.getReoptimizedFlight = function () {
    if (reoptPreviewDataUtilsService.isNdReopt(gridPanel.reoptPreviewData)) {
      if (isFlightManagementGrid()) {
        if (reoptPreviewDataUtilsService.isNdReoptPreview(gridPanel.reoptPreviewData)) {
          return;
        }
        _.forEach(gridPanel.reoptPreviewData.gridDetails, function (gridSettings, gridId) {
          FlightAnalysisGridService.updateReoptPreviewRows(gridId, gridSettings, [gridPanel.reoptPreviewData.ndReopt]);
        });
      } else {
        FlightAnalysisGridService.updateReoptPreviewRows(gridPanel.gridId, gridPanel.jqxGridSettings, [gridPanel.reoptPreviewData.ndReopt]);
      }
      gridPanel.reoptPreviewData.ndReopt.read = true;
    }
  };
  $scope.$on('$destroy', $scope.cancelCheckStatusInterval);
  $scope.isButtonShown = function () {
    return $scope.isReoptimizeButtonShown || isFlightManagementGrid();
  };
  $scope.reOptimize = function (sendRequested, previewRequested, scenarioName) {
    return reoptimizationService.reoptimizeNDFromFlightScreen($scope.selectedRows, scenarioName, sendRequested, previewRequested);
  };
  $scope.onRowSelection = function (event, selectedRows, gridId, allRows, selectedRowIndexes) {
    var isScenarioSelected = scenarioService.isScenarioSelected();
    $scope.selectedRows = setSelectedRowsOnFlightManagement(selectedRows);
    $scope.selectedRowIndexes = setSelectedRowsIndexOnFlightManagement(selectedRowIndexes);
    $scope.hasRows = $scope.selectedRows.length > 0;
    reoptPreviewDataUtilsService.updateFlightDetails(gridPanel.reoptPreviewData, gridPanel, $scope.selectedRows);
    $scope.isReoptimizeButtonShown = !isScenarioSelected && saveButtonUtilsService.isSingleFlightDepartureDateSelected($scope.selectedRows);
    if (reoptPreviewDataUtilsService.isNdReopt(gridPanel.reoptPreviewData) || reoptPreviewDataUtilsService.isMdReopt(gridPanel.reoptPreviewData)) {
      $scope.isReoptimizeButtonShown = $scope.isReoptimizeButtonShown && !(reoptPreviewDataUtilsService.isNdReoptSubmitted(gridPanel.reoptPreviewData) || reoptPreviewDataUtilsService.isMdReoptSubmitted(gridPanel.reoptPreviewData));
    }
    $scope.selectedRows = setSelectedRowsOnFlightManagement(selectedRows);
  };
  $scope.$watch('gridPanelScope.gridDataLoaded', function () {
    if (gridPanel.jqxGridSettings.source && isFlightManagementGrid()) {
      $scope.onRowSelection();
    }
  });
  function isFlightManagementGrid() {
    return flightManagementGrids.indexOf(gridPanel.gridId) > -1;
  }
  function setSelectedRowsOnFlightManagement(selectedRows) {
    if (flightManagementGrids.indexOf(gridPanel.gridId) > -1) {
      return _.size(selectedRows) > 0 ? selectedRows : _.get(gridPanel, 'jqxGridSettings.source.loadedData', []);
    }
    return selectedRows;
  }
  function setSelectedRowsIndexOnFlightManagement(selectedRowIndexes) {
    if (flightManagementGrids.indexOf(gridPanel.gridId) > -1) {
      return _.size(selectedRowIndexes) > 0 ? selectedRowIndexes : _.range(_.size(_.get(gridPanel, 'jqxGridSettings.source.loadedData', [])));
    }
    return selectedRowIndexes;
  }
  function prepareDataForSaving(scenarioName) {
    var dataForSaving = [];
    _.forEach(gridPanel.reoptPreviewData.flightDetails, function (el) {
      dataForSaving.push({
        data: saveButtonUtilsService.getEditedRowsFromData(el.loadedData),
        gridId: el.gridId,
        selectedRows: el.selectedRows,
        scenarioName: scenarioName,
        previewEnabled: reoptPreviewDataUtilsService.isNdReoptPreview(gridPanel.reoptPreviewData),
        userAction: 'reoptPreview'
      });
    });
    return dataForSaving;
  }
  function showError(message) {
    toastr.error(message);
  }
}
GridNDReoptPreviewNotSendButtonController.$inject = ['$scope', '$interval', 'MomentService', 'ScenarioService', 'SaveButtonUtilsService', 'ReoptPreviewDataUtilsService', 'ReoptimizationSaveService', 'ReoptimizationService', 'FlightAnalysisGridService'];
module.exports = GridNDReoptPreviewNotSendButtonController;